import './const/config';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Swiper, { Pagination, Autoplay } from 'swiper';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Vue from 'vue';
// -- 卡券商城添加Lazyload --
import Vant, { Lazyload } from 'vant';

import App from './App';
import router from './router';
import './polyfill';
import { TimeFilter } from './filters/time';
import { NumberFilter } from './filters/number';
import { UBTUtils } from './utils/ubt';
import 'vant/lib/index.css';
import './assets/font/font.less';
import directiveRegister from './directives/index';
// -- 卡券商城添加 start --
import MallApplication from "~mall/common/app";
import store from "~mall/model/store/index";
import '~mall/common/directives/v-expose';
import '~mall/common/utils/url';
// -- 卡券商城添加 end --

Swiper.use([Pagination, Autoplay]);
Vue.use(VueAwesomeSwiper);
Vue.use(Vant);
Vue.use(directiveRegister); // 注册全局自定义指令
// -- 卡券商城添加 start --
Vue.use(Lazyload);
// -- 卡券商城添加 end --

/**
 * 地图业务线key值配置
 * https://lbs.hellobike.cn/#/admin/manage/keyList
 */
window.HBridgeCustomLBSConfig = {
  appKey: 'platform_activity',
  secretKey: 'bd6ba8a794e733a06d02065e7f5d28d9',
};
window.$$location = {};
window.$$user = {};

Vue.filter('time', TimeFilter);
Vue.filter('number', NumberFilter);

UBT.config({
  env: process.env.VUE_APP_ENV,
  debug: process.env.VUE_APP_ENV !== 'pro', // 非生产环境都打开
  categoryId: 'platform',
  urlHelper: {
    // vue项目需在urlHelper项中
    vueRouter: router, // 传入vueRouter实例
  },
  logMaxCount: 1,
  history: false, // 路由模式是否为history模式
});

// 约定window.$$location存储定位信息，包括citycode adcode latitude longitude等
// 约定window.$$user存储用户信息，包括guid token ticket等
// 需要调用api后手动把信息储存在这些位置

UBTUtils.init();

// -- 卡券商城初始化 start --
const mallApp = new MallApplication();
mallApp.init({ router });
// -- 卡券商城初始化 end --

/* eslint-disable no-new */
window.$app = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

export default window.$app;
